import { Review, WithContext } from "schema-dts";
import { TestimonialsDataItem } from "./get-testimonials-data";

const getTestimonialsStructuredData = (
  testimonials: TestimonialsDataItem[],
): WithContext<Review>[] => {
  const result: WithContext<Review>[] = testimonials.map((testimonial) => ({
    "@context": "https://schema.org",
    "@type": "Review",
    author: {
      "@type": "Person",
      name: testimonial.author,
    },
    itemReviewed: {
      "@type": "Organization",
      name: "Orchid",
      url: "https://orchid.exchange/",
    },
    name: testimonial.content,
    reviewRating: {
      "@type": "Rating",
      ratingValue: "5",
      bestRating: "5",
      worstRating: "1",
    },
    datePublished: new Date(testimonial.date).toISOString(),
  }));
  return result;
};

export default getTestimonialsStructuredData;
